import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import UserStore from './store/UserStore';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { TonConnectUIProvider } from '@tonconnect/ui-react';

export const Context = createContext(null);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{
        user: new UserStore()
    }}>
        <TonConnectUIProvider manifestUrl="https://scraplands.ru/tonconnect-manifest.json">
            <App />
        </TonConnectUIProvider>
    </Context.Provider>
);